import _ from 'underscore';

const errorCodesAndMessages = {
  GoalWithSameNameAlreadyExistsUnderTag: _TL_('A goal with this name already exists. Enter a different name.'),
  GoalNameHasInvalidCharacters: _TL_('Your goal name is invalid. Please try a different goal name. If you still encounter issues, please contact support.'),
  DestinationGoalUrlStringTooLong: _TL_('The Destination URL entered is too long. Enter a shorter Destination URL.'),
  GoalTypeCannotBeChanged: _TL_('The type of goal cannot be edited.'),
  InvalidEventGoalCategory: _TL_('Goal category value is invalid.'),
  InvalidEventGoalAction: _TL_('Goal action value is invalid'),
  OnlyOneInStoreTransactionGoalBeAllowedPerCustomer: _TL_('Only one in-store transaction goal can be created per customer.'),
  OnlyOneInStoreVisitGoalBeAllowedPerCustomer: _TL_('We cannot create this conversion goal. There is one store visit conversion goal created across all your accounts. Only one store visit conversion goal can be created across all accounts under your manager account.'),
  InvalidCustomerId: _TL_('The account selected for the goal must be associated with the current manager account.'),
  CustomerUnderMigration: _TL_('Conversion tracking tags and goals data is currently being migrated to a better system. Please try again later.'),
  DestinationGoalURLStringHasInvalidCharacters: _TL_('The Destination URL entered has invalid characters.'),
  CustomerNotEligibleForConversionGoalSelection: _TL_('Manager account not under pilot for conversion goal selection.'),
  DuplicateGoalActionAndOperator: _TL_('A goal with this action already exists. Enter a different action.'),
  HasInvalidUrlExpression: _TL_('The Destination URL entered has invalid characters.'),
  GoalHaveDuplicateName: _TL_('A goal with this name already exists. Enter a different name.'),
  DuplicateGoalName: _TL_('A goal with this name already exists. Enter a different name.'),
  GoalHaveDuplicateURLAndOperator: _TL_('A goal with this Destionation URL already exists. Enter a different Destination URL.'),
  InvalidConversionGoalName: _TL_('This name is invalid or exceeds the length limit.'),
  GoalLevelCannotBeDowngraded: _TL_('The scope of the conversion goal cannot be downgraded to account level.'),
  CustomerNotEligibleForAutoConversion: _TL_('Manager account not under pilot for auto conversion. Please contact the support to enable it.'),
  GoalTagCannotBeChanged: _TL_('A tag cannot be changed for auto conversion goal.'),
  GoalCategoryCannotBeChanged: _TL_('A goal category cannot be changed.'),
  NotAllowedToDoCurrentOperation: _TL_('You don not have permission to update the LTV value now.'),
};

export function getMessageFromErrors(i18n, errors) {
  if (_.isArray(errors)) {
    for (let i = 0; i < _.size(errors); i += 1) {
      const error = errors[i];
      if (error.Code && _.has(errorCodesAndMessages, error.Code)) {
        return i18n.getString(errorCodesAndMessages[error.Code]);
      }
    }
  }

  return null;
}
